<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormStockType
      :StockType="editStockType"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormStockType from '../components/FormStockType.vue';

export default {
  components: {
    FormStockType,
  },
  name: 'EditStockType',
  module: 'StockType',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing StockType. Default to {}.
      */
      editStockType: {},
      /**
       * Query Id for StockType
       */
      stockTypeId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('stockTypes', ['stockTypes', 'stockType']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.stockTypeId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_stockType(this.stockTypeId);
      this.editStockType = this.stockType;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stockTypes', ['LOAD_stockType', 'CREATE_stockType', 'UPDATE_stockType']),
    /** Method used to save the item
     */
    async save(stockType) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_stockType(stockType);
      } else {
        await this.UPDATE_stockType(stockType);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListStockType' });
    },
  },
};
</script>

<docs>
# EditStockType example

'''js
<EditStockType :StockType="StockType" />
'''
</docs>
